import {useState} from 'react';
import {useSearchParams} from "react-router";

import {Link} from "react-router";
import {GoogleOAuthProvider} from '@react-oauth/google';
import ApiHelper from "@/helpers/ApiHelper";
import AuthRequests from "@/requests/Users/AuthRequests";
import GoogleLogin from "./GoogleLogin.jsx";
import GoogleAuthProcessing from "./GoogleAuthProcessing.jsx";

export default function Login() {
    const apiHelper = new ApiHelper();
    const authRequests = new AuthRequests(apiHelper);

    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get('returnTo') || '/';

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [error, setError] = useState('');
    const [googleAuthProcessing, setGoogleAuthProcessing] = useState(false);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (email === '' || password === '') {
            setError('Будь ласка, заповніть всі поля');
            return;
        }

        authRequests.login(email, password, rememberMe, () => {
            setError('Сталася помилка. Будь ласка, повторіть ваш запит.');
        }).then(() => {
            window.location.href = redirectTo;
        });
    }


    const onGoogleAuth = (googleAuthCode) => {
        setGoogleAuthProcessing(true);
        setError('');

        apiHelper.postRequest('/auth/login-with-google', {googleAuthCode}).then((response) => {
            if (response?.data?.success) {
                window.location.href = redirectTo;
            } else {
                setGoogleAuthProcessing(false);
                setError('Не вдалося увійти через Google.');
            }
        }).catch(() => {
            setGoogleAuthProcessing(false);
            setError('Не вдалося увійти через Google.');
        });
    }


    if (googleAuthProcessing) {
        return <GoogleAuthProcessing />;
    }

    return (
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <form onSubmit={handleSubmit}>
                {error !== '' && <div className="alert alert-danger" role="alert">{error}</div>}

                <div className="mb-4">
                    <label htmlFor="split-login-email" className="form-label">E-mail</label>
                    <input type="email" className="form-control" id="split-login-email" aria-describedby="emailHelp" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>

                <div className="mb-4">
                    <label htmlFor="split-login-password" className="form-label">Пароль</label>
                    <input type="password" className="form-control" id="split-login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>

                <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="form-check">
                        <input className="form-check-input primary" type="checkbox" id="split-checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                        <label className="form-check-label text-dark" htmlFor="split-checkbox">
                            Запам'ятати мене
                        </label>
                    </div>
                    <Link className="text-primary fw-medium" to="/auth/forgot-password">Забули пароль?</Link>
                </div>


                <div className="d-flex align-items-center justify-content-between mb-4">
                    <button className="btn btn-primary w-40 justify-content-center" type="submit" name="submit">Увійти</button>
                </div>
            </form>

            <div className="position-relative text-center my-4">
                <p className="mb-0 fs-4 px-3 d-inline-block bg-white text-dark z-index-5 position-relative">або</p>
                <span className="border-top w-100 position-absolute top-50 start-50 translate-middle"></span>
            </div>

            <div className="row">
                <div className="col-12 mb-2 mb-sm-0">
                    <GoogleLogin onGoogleAuth={onGoogleAuth} />
                </div>
            </div>
        </GoogleOAuthProvider>
    );
}
